import React, { useState, useEffect } from "react";
import "./Feedback.css";
import { useNavigate } from "react-router-dom";

function Feedback({ isSuccess, onClose, onLoginTrigger  }) {
 const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();

      if (isSuccess?.redirectTo) {
        navigate(isSuccess.redirectTo);
      }

      if (isSuccess?.triggerLogin && typeof onLoginTrigger === "function") {
        onLoginTrigger();
      }
    }, isSuccess?.delay || 3000);

    return () => clearTimeout(timer);
  }, [isSuccess, onClose, onLoginTrigger, navigate]);

  if (!isSuccess?.show) return null;

 
  const getIconClass = () => {
    switch (isSuccess.status) {
      case "success":
        return "bi bi-check-circle-fill";
      case "failure":
        return "bi bi-x-circle-fill";
      case "warning":
        return "bi bi-exclamation-triangle-fill";
      default:
        return "bi bi-info-circle-fill";
    }
  }

  return (
    <>
      <div className="modal-overlay" id="modal">
        <div className="modal">
          <div className="success-circle">
            <i className={getIconClass()}></i>
          </div>
          <h2>{isSuccess.title}</h2>
          <p>{isSuccess.message}</p>
          {/* <button onClick={onClose}>OK</button> */}
        </div>
      </div>
    </>
  );
}

export default Feedback;